<template>
  <div class="big-table">
    <div class="table-holder" v-on:scroll="handleTableScroll" v-if="table">
      <table class="mdl-data-table mdl-js-data-table mdl-shadow--2dp">
        <thead v-bind:style="{ top: tableScrollY + 'px' }">
          <tr>
            <th v-for="(columnName, colId) in table.columnNames"
                class="sort"
                v-bind:class="[{
                  desc: sortColumn == columnName && !sortAsc,
                  asc: sortColumn == columnName && sortAsc,
                  'mdl-data-table__cell--non-numeric': table.columnTypes[colId] != 'number'
                }, 'col-'+table.columnTypes[colId]]"
                v-on:click="toggleSort(columnName)">
              <span v-bind:id="generateId('th-'+columnName)">{{ table.displayColumnNames[colId] }}</span>
              <div class="mdl-tooltip" v-bind:data-mdl-for="generateId('th-'+columnName)">
                {{ table.displayColumnNames[colId] }}
              </div>
            </th>
          </tr>
          <tr v-if="showSummary">
            <td class="mdl-data-table__cell--non-numeric">
              Summary:
            </td>
            <td v-for="(columnName, colId) in table.columnNames.slice(1)"
                v-bind:class="[{
                  'mdl-data-table__cell--non-numeric': table.columnTypes[colId+1] != 'number'
                }, 'col-'+table.columnTypes[colId+1], generateClass(table.columnNames[colId + 1])]">
              <span v-bind:id="generateId('sum-'+columnName)">{{ cellText(table.summary[colId+1]) }}</span>
            </td>
          </tr>
        </thead>
        <tbody v-bind:style="{ marginTop: (tableMargins[0] + tableTopHeight) + 'px', marginBottom: tableMargins[1] + 'px' }">
          <tr v-for="(row, vRowId) in visiblePart" :key="visiblePartRowsRange[0]+vRowId">
            <td v-for="(cell, colId) in row" :key="colId"
                v-bind:class="[
                  {
                    'mdl-data-table__cell--non-numeric': table.columnTypes[colId] != 'number',
                    found: foundMap[(visiblePartRowsRange[0]+vRowId)+'-'+(colId)]
                  },
                  'col-'+table.columnTypes[colId],
                  generateClass(table.columnNames[colId])
                ]">
                  <span v-if="table.columnTypes[colId] != 'ad'"
                        v-bind:id="generateId('td-'+(visiblePartRowsRange[0]+vRowId)+'-'+colId)"
                        v-bind:title="cellText(cell)">
                    {{ cellText(cell) }}
                  </span>
                  <div v-if="table.columnTypes[colId] == 'ad'"
                        v-bind:id="generateId('td-'+(visiblePartRowsRange[0]+vRowId)+'-'+colId)"
                        v-bind:title="cell.title"
                        class="ad">
                    <div class="title">
                      {{ cell.title }}
                    </div>
                    <div class="text">
                      {{ cell.text }}
                    </div>
                    <div class="url">
                      {{ cell.url }}
                    </div>
                  </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
  import config from "../../config"

  export default {
    name: 'big-table',
    props: {
      table: {
        type: Object
      },
      sortColumn: {
        type: String
      },
      sortAsc: {
        type: Boolean
      },
      found: {
        type: Array
      },
      rowHeight: {
        type: Number,
        default() { return 49 }
      },
      firstColumnWidth: {
        type: Number,
        default() { return 200 }
      },
      showSummary: {
        type: Boolean,
        default: true
      }
    },
    data () {
      return {
        tableScrollY: 0,
        invisibleRows: config.view.table.invisibleRows,
        clusterSize: config.view.table.partitionSize,
        maxTableRows: config.view.table.visibleRange,
        visiblePartRowsRange: [ config.view.table.partitionSize, config.view.table.visibleRange ],
        visiblePart: null,
        resizeListener: null
      }
    },
    computed: {
      tableTopHeight() {
        let height = 46;
        if(this.showSummary) height += 46
        return height
      },
      renderedRowsRange() {
        const firstVisibleRow = (this.tableScrollY / this.rowHeight) | 0
        const notClusterized = Math.max(0, firstVisibleRow - this.invisibleRows)
        const clusterSize = this.clusterSize
        const clusterized = ( ( notClusterized / clusterSize ) | 0 ) * clusterSize
        //console.log("CLUSTERIZE", notClusterized, clusterized)
        const last = Math.min(this.table.rows.length - 1, clusterized + this.maxTableRows)
        return [clusterized, last]
      },
      tableMargins() {
        const rowsRange = this.renderedRowsRange
        const top = rowsRange[0] * this.rowHeight
        const bottom = (this.table.rows.length - rowsRange[1] - 1) * this.rowHeight
        return [top, bottom]
      },
      foundMap() {
        let map = {}
        const found = this.found
        if(!found) return map
        for(let el of found) {
          const cellId = el.rowId + '-' + el.columnId
          map[cellId] = map[cellId] || []
          map[cellId].push(el)
        }
        return map
      }
    },
    watch: {
      table() {
        this.sliceVisiblePart(true)
        setTimeout(() => this.resize(), 50)
      },
      renderedRowsRange() {
        this.sliceVisiblePart(false)
        setTimeout(() => this.resize(), 50)
      },
      found(found) {
        if(found.length == 0) return;
        let y = found[0].rowId * this.rowHeight
        document.querySelector(".big-table .table-holder").scrollTop = y
      }
    },
    methods: {
      toggleSort(column) {
        this.$emit('toggleSort', column)
      },
      handleTableScroll(e) {
        this.tableScrollY = e.target.scrollTop
      },
      generateId(text) {
        return text.toLowerCase().replace(/[^a-zA-Z0-9-]/g, '-')
      },
      generateClass(text) {
        if(!text) return "cg-error"
        return text.toLowerCase().replace(/[^a-z]/g, '-')
      },
      addThousandSeparator(nStr) {
        nStr += '';
        let x = nStr.split('.');
        let x1 = x[0];
        let x2 = x.length > 1 ? '.' + x[1] : '';
        var rgx = /(\d+)(\d{3})/;
        while (rgx.test(x1)) {
          x1 = x1.replace(rgx, '$1' + '\u00A0' + '$2');
        }
        return x1 + x2;
      },
      cellText(cell) {
        if(typeof cell == "number") return this.addThousandSeparator((cell % 100) == 0 ? cell / 100 : (cell / 100).toFixed(2))
        return cell
      },
      sliceVisiblePart(force) {
        const rowsRange = this.renderedRowsRange
        if(rowsRange[0] != this.visiblePartRowsRange[0] || rowsRange[1] != this.visiblePartRowsRange[1] || force) {
          this.visiblePartRowsRange[0] = rowsRange[0]
          this.visiblePartRowsRange[1] = rowsRange[1]
          //console.log("RECOMPUTE VISIBLE PART", rowsRange.join(' .. '))
          this.visiblePart = this.table.rows.slice(rowsRange[0], rowsRange[1]+1)
        }
      },
      resize() {
        const thead = this.$el.querySelector('.table-holder thead tr')
        let otherWidth = 0
        for(let el = thead.firstElementChild.nextElementSibling; el; el = el.nextElementSibling) {
          otherWidth += el.clientWidth
        }
        let spaceWidth = this.$el.querySelector('.table-holder').clientWidth - 5
        let remainingWidth = spaceWidth - otherWidth
        let firstColumnWidth = Math.max(this.firstColumnWidth, remainingWidth)
        console.log("REMAINING WIDTH", remainingWidth, "SPACE WIDTH", spaceWidth, "COLUMNS WIDTH", otherWidth)
        const widthString = firstColumnWidth + 'px'
        let cell = this.$el.querySelector('.table-holder thead tr').firstElementChild
        cell.style.width = widthString
        cell.style.maxWidth = widthString
        cell.style.minWidth = widthString
        let rows = this.$el.querySelectorAll("tr")
        for(let i = 0; i < rows.length; i++) {
          cell = rows[i].firstElementChild
          cell.style.width = widthString
          cell.style.maxWidth = widthString
          cell.style.minWidth = widthString
        }
      }
    },
    mounted() {
      this.sliceVisiblePart(true)
      setTimeout(() => this.resize(), 50)
      this.resizeListener = () => this.resize()
      window.addEventListener('resize', this.resizeListener)
    },
    beforeDestroy () {
      window.removeEventListener('resize', this.resizeListener)
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

  .table-holder {
    position: absolute;
    right: 0em;
    left: 0em;
    top: 0em;
    bottom: 0em;
    width: auto;
    height: auto;
    overflow-x: auto;
  }
  .table-scroll {
    position: absolute;
    right: 0em;
    left: 0em;
    width: auto;
    top: 1em;
    bottom: 0em;
    height: auto;
    overflow-y: auto;
  }

  thead, tbody tr {
    display: table;
    table-layout: fixed;
  }

  thead {
    position: absolute;
    background: white;
    z-index: 1;
    border-top: 2px solid #cecece;
    border-bottom: 2px solid #cecece;
    margin-top: -2px;
  }

  tbody {
    margin-top: 46px;
    display: block;
    overflow-x: hidden;
    overflow-y: visible;
  }

  td {
  }

  th, td {
    text-overflow: ellipsis;
    overflow: hidden;
  }
  th:focus, th span:focus {
    outline:0;
  }
  th, td {
    width: 150px;
    min-width: 123px;
    max-width: 123px;
    /* border: 1px solid black; */
  }
  th.col-text, td.col-text {
    width: 200px;
    min-width: 200px;
    max-width: 200px;
  }

  td.ctr:after {
    content: "%"
  }
  td.roc:after {
    content: "%"
  }
  td.cr:after {
    content: "%"
  }
  td.found {
    background: #ffc766;
  }

  th.sort {
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    /* min-width: 75px; */
  }
  th.sort:hover {
    cursor: pointer;
    text-decoration: none;
  }
  th.sort:focus {
    outline:none;
  }
  th.sort:before {
    display:inline-block;
    width: 0;
    height: 0;
    border-left: 5px solid transparent;
    border-right: 5px solid transparent;
    border-bottom: 5px solid transparent;
    content:"";
    position: relative;
    top:-10px;
    right:3px;
  }
  th.sort.desc:before {
    width: 0;
    height: 0;
    border-left: 5px solid transparent;
    border-right: 5px solid transparent;
    border-top: 5px solid black;
    content:"";
    position: relative;
    top:4px;
    right:3px;
  }
  th.sort.asc:before {
    width: 0;
    height: 0;
    border-left: 5px solid transparent;
    border-right: 5px solid transparent;
    border-bottom: 5px solid black;
    content:"";
    position: relative;
    top:-4px;
    right:3px;
  }

  .ad {
    text-overflow: clip;
  }
  .ad  .title {
    color: #1a0dab;
  }

  .ad .url {
    color: #006621;
  }

</style>



// WEBPACK FOOTER //
// BigTable.vue?8a9457ec